export default "__VITE_ASSET__BLmjvK0L__"